var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":"","small":_vm.small,"aria-label":`Retour : ${_vm.text}`},on:{"click":_vm.go}},[_c('v-icon',{class:{ 'mr-2': !_vm.small },attrs:{"small":_vm.small,"left":_vm.small}},[_vm._v("mdi-chevron-left")]),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }